import { PortableText } from 'next-sanity';
import { richTextComponent } from '@/sanity/sanityPortableText';
import { resolveI18nText, resolveI18nRichtext } from '@/sanity/globals/I18n';
import { IPricingSectionV2 } from '@/sanity/lib/definitions';

export default function PricingHeroBlock({
  data,
  language,
}: {
  data: IPricingSectionV2;
  language?: string;
}) {
  const chip = resolveI18nText(data.heroChip, data.heroChipI18n, language);
  const content = resolveI18nRichtext(
    data.heroContent,
    data.heroContentI18n,
    language,
  );

  if (!chip && !content?.length) return null;

  return (
    <div className="flex flex-col items-center gap-[1.5rem] md:gap-[2rem] text-center">
      {chip && (
        <p className="mb-0 font-blacker italic text-[1.75rem] md:text-[2rem] leading-[1.5] text-black">
          {chip}
        </p>
      )}
      {content && (
        <div className="richtext flex flex-col gap-[1.5rem] md:gap-[2rem]">
          <PortableText value={content} components={richTextComponent} />
        </div>
      )}
    </div>
  );
}
